import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconShirt({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<path id="a" d="M.217 37.037h37.037V0H.217z" />
				<path
					id="c"
					d="M17.51 14.56h5.142l.006.389v3.466c-.001.432-.312.797-.72.819l-.037.001h-3.635c-.414 0-.737-.353-.756-.782V14.56"
				/>
			</defs>
			<g fill="none" fillRule="evenodd" transform="translate(-6.13 -5.9)">
				<mask id="b" fill="#fff">
					<use xlinkHref="#a" />
				</mask>
				<g mask="url(#b)">
					<path
						fill="#CD0400"
						d="M15.83 9.141c1.506 1.814 3.558 1.823 4.954 0zm-3.982 13.453c0-1.256-.013-2.513.008-3.769.006-.311-.11-.412-.385-.486a260 260 0 0 1-3.713-1.04c-.598-.171-.757-.503-.527-1.072q.783-1.933 1.567-3.866c.467-1.151 1.276-1.992 2.384-2.524a77 77 0 0 1 3.18-1.408c.228-.097.494-.14.743-.141q3.228-.015 6.455 0c.238 0 .488.047.71.132 1.071.411 2.143.824 3.2 1.272 1.345.571 2.307 1.522 2.8 2.926.416 1.18.865 2.348 1.297 3.522.235.64.079.942-.586 1.142-1.186.357-2.37.723-3.56 1.066-.251.072-.315.189-.314.438.01 2.489.006 4.978.006 7.467 0 .844-.239 1.182-1.04 1.423-2.15.646-4.35.81-6.581.676a24.4 24.4 0 0 1-4.632-.731c-.706-.182-1.012-.57-1.012-1.294z"
					/>
					<path
						fill="#FFF"
						d="M22.187 9.33c-.382.312-.71.557-1.012.83-1.062.955-2.263 1.463-3.704 1.11-1.065-.262-1.902-.905-2.599-1.728-.186-.22-.33-.246-.582-.128-.798.373-1.608.722-2.414 1.08-.81.359-1.525.874-1.897 1.676-.653 1.406-1.21 2.858-1.825 4.334l3.694 1.037c0-.887-.014-1.712.011-2.536.005-.169.11-.397.244-.488.345-.235.72.034.72.49q.002 5.585.002 11.17c0 .52.028.551.541.673 1.598.38 3.216.612 4.858.663 1.892.058 3.757-.122 5.578-.67.23-.07.336-.201.331-.457-.014-.733-.005-1.466-.005-2.2 0-3.06.002-6.12-.003-9.18 0-.235.054-.446.279-.5.169-.042.403-.019.54.075.11.074.159.298.162.457.015.812.007 1.625.007 2.49l3.51-1.058c-.036-.125-.059-.223-.093-.318-.407-1.11-.823-2.215-1.223-3.328-.378-1.054-1.087-1.814-2.094-2.262-1.047-.467-2.123-.868-3.026-1.232"
					/>
				</g>
				<mask id="d" fill="#fff">
					<use xlinkHref="#c" />
				</mask>
				<use xlinkHref="#c" fill="#CD0400" fillRule="nonzero" />
				<path
					fill="#FFF"
					d="m39.758 12.091-7.782 1.15-1.604.237-7.782 1.15-1.605.238-7.782 1.15-1.604.237-7.782 1.15-.367.491 8.645-1.278.742-.11 8.644-1.277.742-.11 8.644-1.277.742-.11 8.645-1.278M38.41 11.103l-5.435.803-3.952.584-5.435.803-3.95.584-5.436.804-3.951.584-5.436.803-.367.49 6.299-.93 3.088-.457 6.298-.93 3.088-.457 6.298-.93 3.088-.457 6.299-.93M39.758 14.391l-7.782 1.15-1.604.237-7.782 1.15-1.605.238-7.782 1.15-1.604.237-7.782 1.15-.367.491 8.645-1.278.742-.11 8.644-1.277.742-.11 8.644-1.277.742-.11 8.645-1.278M38.41 13.403l-5.435.803-3.952.584-5.435.803-3.95.584-5.436.804-3.951.584-5.436.803-.367.49 6.299-.93 3.088-.457 6.298-.93 3.088-.457 6.298-.93 3.088-.457 6.299-.93M39.758 16.691l-7.782 1.15-1.604.237-7.782 1.15-1.605.238-7.782 1.15-1.604.237-7.782 1.15-.367.491 8.645-1.278.742-.11 8.644-1.277.742-.11 8.644-1.277.742-.11 8.645-1.278M38.41 15.703l-5.435.803-3.952.584-5.435.803-3.95.584-5.436.804-3.951.584-5.436.803-.367.49 6.299-.93 3.088-.457 6.298-.93 3.088-.457 6.298-.93 3.088-.457 6.299-.93"
					mask="url(#d)"
				/>
			</g>
		</svg>
	);
}
